<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><img alt="" src="OEBPS/images/9781936535408_tp.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781936535408_epub_tp_r1.vue?1ed80512